import type { DefaultSetAttributes } from '../../../generated/api.graphql';
import { take } from '../../../util';
import type { Defaults } from './DefaultSet';

export type DefaultSetInput = {
  id?: number;
  defaults: Defaults;
};

export const toGqlInput = (input: DefaultSetInput): DefaultSetAttributes =>
  take(input, 'id', 'defaults');
